import { Dialog, Transition } from '@headlessui/react';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Fragment } from 'react';

export default function ModalItemPindah({ isOpenModalPindah, closeModalPindah, cabang }) {
  return (
    <>
      <Transition appear show={isOpenModalPindah} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModalPindah}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-md bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="div"
                    className="text-red-500   flex justify-center font-medium leading-6 "
                  ></Dialog.Title>
                  <div>
                    <div className="bg-white rounded-lg md:max-w-md ">
                      <div className="flex items-center gap-4">
                        <div className=" flex items-center justify-center w-16 h-16 ">
                          <IconAlertTriangle className="border rounded-full p-2" width={70} height={70} />
                        </div>
                        <div className="mt-4  md:ml-2  md:text-left">
                          <p className="font-bold ">Apakah anda yakin untuk memindah barang ini?</p>
                          <div className="relative rounded-md  group  py-1">
                            <select
                              // onChange={(e) => setSelectCabang(e.target.value)}
                              className="border p-2 rounded-md cursor-pointer shadow-md"
                            >
                              <option className="pt-6" value="">
                                Semua Etalase
                              </option>
                              {cabang.map((cb) => (
                                <option key={cb.id} value={cb.id}>
                                  {cb.nama_cabang}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="text-right mt-2 gap-2  flex justify-end">
                        <button className="bg-red-500 rounded-md text-white px-4 py-2">Simpan</button>
                        <button onClick={closeModalPindah} className="bg-slate-500 rounded-md text-white px-4 py-2">
                          Batal
                        </button>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
